/* istanbul ignore next */
export function isResponseContainsKey<S extends object>(response: S, key: string): response is S {
  return key in (response as S);
}
